export type BrokerageBrand = {
  slug: string
  name: string
  /** CDN / local asset filename when it differs from slug (e.g. moomoo.webp for Momo). */
  iconSlug?: string
}

/** Homepage strip — Figma `288:80864` / Frame 2147239492 (left-to-right scroll order). */
export const homeBrokerageStrip: BrokerageBrand[] = [
  { slug: 'empower', name: 'Empower' },
  { slug: 'etoro', name: 'Etoro' },
  { slug: 'fidelity', name: 'Fidelity' },
  { slug: 'interactive-brokers', name: 'Interactive Brokers' },
  { slug: 'kraken', name: 'Kraken' },
  { slug: 'momo', name: 'Momo', iconSlug: 'moomoo' },
  { slug: 'pnc', name: 'PNC' },
  { slug: 'robinhood', name: 'Robinhood' },
  { slug: 'schwab', name: 'Schwab' },
  { slug: 'tastytrade', name: 'Tastytrade' },
  { slug: 'tiaa', name: 'TIAA' },
  { slug: 'tradestation', name: 'TradeStation' },
]

/** Broader list for integrations and FAQ references. */
export const supportedBrokerages: BrokerageBrand[] = [
  { slug: 'alpaca', name: 'Alpaca', iconSlug: 'alpaca-paper' },
  { slug: 'chase', name: 'Chase' },
  { slug: 'coinbase', name: 'Coinbase' },
  { slug: 'empower', name: 'Empower' },
  { slug: 'etrade', name: 'E*TRADE' },
  { slug: 'etoro', name: 'eToro' },
  { slug: 'fidelity', name: 'Fidelity' },
  { slug: 'interactive-brokers', name: 'Interactive Brokers' },
  { slug: 'kraken', name: 'Kraken' },
  { slug: 'momo', name: 'MooMoo', iconSlug: 'moomoo' },
  { slug: 'pnc', name: 'PNC' },
  { slug: 'public', name: 'Public' },
  { slug: 'robinhood', name: 'Robinhood' },
  { slug: 'schwab', name: 'Schwab' },
  { slug: 'tastytrade', name: 'tastytrade' },
  { slug: 'tiaa', name: 'TIAA' },
  { slug: 'tradestation', name: 'TradeStation' },
  { slug: 'vanguard', name: 'Vanguard' },
  { slug: 'webull', name: 'Webull' },
  { slug: 'wells-fargo', name: 'Wells Fargo' },
]
